
document.addEventListener('readystatechange', (event) => {
  const funding_data = document.getElementById('financement');
  if (!funding_data) return;
  const domain = "https://ui.vivafi.fr/v3";
  const iframe = "simulateur";
  const parametres = {
    "T20_Simulateur_Code": "FI",
    "T20_Partenaire_Code": "GRIM"
  };
  let bien = {
    'T10_Concession_Code': funding_data.dataset.citycode,
    'T10_Marque_Code': funding_data.dataset.brandcode,
    'F11_Bien_PrixTTC': funding_data.dataset.price,
  };
  if ( funding_data.dataset.registration ) {
    bien['BL_Tva_Applicable'] = true;
    bien['T10_Immatriculation'] = funding_data.dataset.registration;
  }
  window.vivafi.ouvrirSimulateur(domain, iframe, bien, parametres);
});
